export const sxStyled = theme => ({
  airlineLogo: {
    width: '35px',
    height: '35px',
  },
  carrierName: {
    fontSize: { xs: '16px', xl: '18px' },
    paddingLeft: { xs: '0px', lg: '8px', xl: '16px' },
    color: '#000000',
  },
  priceConcept: {
    fontSize: '16px',
    color: '#636466',
  },
  priceValueContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
  },
  priceValue: {
    textAlign: 'end',
    fontSize: '16px',
    color: '#636466',
  },
  titlePay: {
    margin: '15px 0',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  separatorHorizontal: {
    height: '1px',
    width: '100%',
    marginTop: '10px',
    backgroundColor: 'rgba(34, 34, 34, 0.2)',
  },
  textCenter: {
    textAlign: 'center',
    marginBottom: '5px',
    fontWeight: 600,
    color: 'inherit',
  },
  total: {
    color: '#FF2020',
    fontWeight: '600',
    fontSize: '18px',
    marginTop: '10px',
  },
  totalPrice: {
    textAlign: 'end',
    marginTop: '10px',
    color: '#FF2020',
    fontSize: '18px',
    fontWeight: '600',
  },
  boxCarrier: {
    width: { xs: '100%', sm: '90%' },
    fontFamily: 'Open Sans, sans-serif',
    borderBottom: '1px solid #E5E5E5',
  },
  gridCarrier: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: { xs: '0px', sm: '2vh' },
    paddingTop: { xs: '2px', sm: '0px' },
  },
  gridContainerBagg: {
    marginBottom: { xs: '15px', sm: '2vh' },
  },
  centerBaggage: {
    display: 'flex',
    justifyContent: { xs: 'space-between', sm: 'center' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    marginTop: { xs: '0.6rem', sm: '0px' },
  },
  equipaje: {
    color: '#000000',
    fontWeight: 700,
    fontSize: '14px',
    textAlign: 'center',
  },
  boxEquipaje: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: { xs: '5px', sm: '0px' },
  },
  boxCarrierFlex: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: { xs: '15px', sm: '2vh' },
  },
  boxVuelta: {
    marginBottom: { xs: '15px', sm: '2vh' },
    marginTop: { xs: '10px', sm: '2vh' },
  },
  compartirButton: {
    width: '100%',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    color: theme.tertiary,
    '&:hover': {
      background: 'none',
    },
  },
});
